var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owner-room-container"},[_c('div',{staticClass:"bg-white index-1-right-item"},[_c('div',{staticClass:"index-title"},[_c('span',[_vm._v(_vm._s(_vm.$t('propertyIndex.residentRegStats')))])]),_c('div',{staticStyle:{"height":"250px"},attrs:{"id":"ownerRoomCount"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }